import React, { useState } from "react";
import "./TransactionHistory.css";
import { downloadInvoice } from "../../API/ApiService";
import NoTransaction from "./NoTransaction";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour12: true, 
    timeZone: "UTC",
  });
};


const formatShortDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    // second: "2-digit",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour12: true, 
    timeZone: "UTC", 
  });
};


// Keep transactions and setTransactions props
function TrasactionHistoryCard({ transaction, setTransactions, transactions }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleViewInvoice = (billLink) => {
    if (billLink) {
      window.open(billLink, "_blank");
    }
  };

  const currentTransactionData = transactions.find(
    // Find using business_uuid
    (t) => t.business_uuid === transaction.business_uuid
  );
  const invoices = currentTransactionData?.invoices;
  const fetchFailed = currentTransactionData?.invoice_fetch_failed;

  const handleExpandCard = async () => {
    // Use business_uuid from the transaction prop
    const targetBusinessUuid = transaction.business_uuid;
    const currentlyExpanded = !isExpanded;
    setIsExpanded(currentlyExpanded);

    if (currentlyExpanded && !invoices && !fetchFailed) {
      setIsLoading(true); // Start loading
      try {
        // Pass the business_uuid in the payload object
        const payload = { business_uuid: targetBusinessUuid };
        const response = await downloadInvoice(payload);
        if (response?.data?.status === 200) {
          const fetchedInvoices = response.data.result || [];
          // Update the shared transactions state via the prop function
          const updatedTransactions = transactions.map((t) => {
            // Match using business_uuid
            if (t.business_uuid === targetBusinessUuid) {
              return {
                ...t,
                invoices: fetchedInvoices,
                invoice_fetch_failed: false,
              };
            }
            return t;
          });
          setTransactions(updatedTransactions);
        } else {
          console.error("Failed to fetch invoices:", response?.data);

          const updatedTransactions = transactions.map((t) => {
            if (t.business_uuid === targetBusinessUuid) {
              // Keep existing data but mark as failed to prevent retries
              return {
                ...t,
                invoices: t.invoices || [],
                invoice_fetch_failed: true,
              };
            }
            return t;
          });
          setTransactions(updatedTransactions);
        }
      } catch (error) {
        console.error("Error fetching invoices:", error);

        const updatedTransactions = transactions.map((t) => {
          // Match using business_uuid
          if (t.business_uuid === targetBusinessUuid) {
            return {
              ...t,
              invoices: t.invoices || [],
              invoice_fetch_failed: true,
            };
          }
          return t;
        });
        setTransactions(updatedTransactions);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const displayInvoices = isExpanded ? invoices : null;

  return (
    // Use local isExpanded state for class
    <div className={`transaction-card ${isExpanded ? "expanded" : ""}`}>
      <div className="card-main-content">
        <div className="business-info">
          <div className="business-image">
            <img
              src={transaction.profile_image}
              alt={transaction.business_name}
            />
          </div>
          <div className="business-details">
            <h3>{transaction.business_name}</h3>

            {/* Use local isExpanded state */}
            {!isExpanded && transaction.latest_payment_datetime && (
              <div className="latest-transaction-info">
                <span className="transaction-date">
                  {formatShortDate(transaction.latest_payment_datetime)}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="transaction-amount-container">
          {/* Use local isExpanded state */}
          {!isExpanded && transaction.latest_customer_pay_amount && (
            <div className="transaction-amount">
              ${transaction.latest_customer_pay_amount}
            </div>
          )}
          <button
            className="expand-button"
            onClick={handleExpandCard}
            disabled={isLoading}
          >
            <img
              src="../images/expand_icon.png"
              alt="Expand"
              style={{
                transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            />
          </button>
        </div>
      </div>

      {/* Use local isExpanded state */}
      {isExpanded && (
        <div className="dropdown-content">
          {isLoading ? (
            <div className="loading-invoices">Loading invoices...</div>
          ) : fetchFailed ? (
            <NoTransaction message="Failed to load invoices." />
          ) : displayInvoices && displayInvoices.length > 0 ? (
            // Use invoices from shared state (displayInvoices)
            displayInvoices.map((invoice) => (
              <div key={invoice.id} className="dropdown-item">
                <div className="item-left">
                  <div className="doc-icon-container">
                    <img src="../images/doc_icon.png" alt="" />
                  </div>
                  <div className="item-details">
                    <div className="item-id">Invoice #{invoice.invoice_id}</div>
                    <div className="item-date">
                      {formatDate(invoice.created_at)}
                    </div>
                  </div>
                </div>
                <div className="item-right">
                  <div className="item-amount">
                    ${invoice.customer_pay_amount}
                  </div>
                  {invoice.status === 1 ? (
                    <button
                      className={`view-button ${
                        !invoice.bill_link ? "disabled" : ""
                      }`}
                      onClick={() =>
                        invoice.bill_link &&
                        handleViewInvoice(invoice.bill_link)
                      }
                      disabled={!invoice.bill_link}
                    >
                      <img
                        src="../images/view_btn_transcation.png"
                        alt="View"
                      />
                      <span>View</span>
                    </button>
                  ) : (
                    <div className="failed-status">
                      <img src="../images/failed_icon.png" alt="Failed" />
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            !isLoading &&
            !fetchFailed && (
              <NoTransaction message="No invoices found for this business." />
            )
          )}
        </div>
      )}
    </div>
  );
}

export default TrasactionHistoryCard;
